define('viewModels/privileged/qm/AnnotationView',[
    'lib/knockout',
    'lib/lodash4',
    'services/loggingService',
    'viewModels/privileged/qm/AnnotationTypeResources',
    'viewModels/ViewModel'
], function (ko, _, LOG, AnnotationTypeResources, ViewModel) {
    'use strict';

    var AnnotationView = ViewModel.extend(function (annotation,
                                                    totalAudioDurationInMs) {
        var self = this;

        var location = ko.utils.unwrapObservable(annotation.location);
        var durationMs = ko.utils.unwrapObservable(annotation.durationMs);
        var type = ko.utils.unwrapObservable(annotation.type);
        var description = ko.utils.unwrapObservable(annotation.description);

        self.location = ko.observable(location);

        // Find where this annotation is on the time axis
        self.percentPosition = ko.observable(0);
        if (totalAudioDurationInMs > 0) {
            var percentPosition = location / totalAudioDurationInMs * 100;
            if (!isNaN(percentPosition)) {
                self.percentPosition(percentPosition);
            }
        }

        // Determine if this annotation has a duration and if so, what it is
        self.hasDuration = ko.observable(false);
        if (totalAudioDurationInMs && totalAudioDurationInMs > 0) {
            if (annotation && _.isInteger(durationMs)) {
                self.hasDuration(true);
                self.durationPercentage = ko.observable(durationMs / totalAudioDurationInMs * 100);
            }
        }

        // What kind of annotation is it?

        var annotationTypeResource = AnnotationTypeResources[type.toLowerCase()] || AnnotationTypeResources.unknown;
        self.iconClassName = ko.observable(annotationTypeResource.iconClassName);
        self.labelKey = ko.observable(annotationTypeResource.labelKey);

        // Fill out tooltip details
        var secondsString = ko.i18n.renderString('annotation.seconds');
        self.isTooltipVisible = ko.observable(false);
        self.displayProperties = ko.observableArray([]);
        self.displayProperties.push({
            'nameKey' : 'annotation.time',
            'value' : (location / 1000).toFixed(1) + ' ' + secondsString
        });
        if (self.hasDuration()) {
            self.displayProperties.push({
                'nameKey' : 'annotation.duration',
                'value' : (durationMs / 1000).toFixed(1) + ' ' + secondsString
            });
        }
        if (annotation.description) {
            self.displayProperties.push({
                'nameKey' : 'annotation.description',
                'value' : description
            });
        }

        self.showTooltip = function () {
            self.isTooltipVisible(true);
        };

        self.hideTooltip = function () {
            self.isTooltipVisible(false);
        };

        //Add the information from an additional annotation at the same location to this one.
        //Eventually we may want to do something more sophisticated than this but for now
        //this only adds an additional description
        self.addAnnotation = function(annotation) {

            if (annotation.description) {
                self.displayProperties.push({
                    'nameKey' : 'annotation.description',
                    'value' : ko.utils.unwrapObservable(annotation.description)
                });
            }
        };

    });

    return AnnotationView;
});

